import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { PRIMARY, TEXT } from '../../../../../shared/Helpers/colors';
import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { InfoFilled } from '../../../../../shared/Assets/svgIcons';

import { DispatchProperties } from '../../../../../redux/store';
import { BehaviorReductionProperties } from '../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { getFrequency, updateFrequency } from '../../../../../redux/State/clientSlice/dataCollectionSlice';

const FrequencyType = ({ behavior }: { behavior: BehaviorReductionProperties }) => {
	const { sessionId } = useParams();
	const dispatch = useDispatch<DispatchProperties>();

	const [count, setCount] = useState<number>(0);
	const [openInfo, setOpenInfo] = useState<boolean>(false);
	const [flag, setFlag] = useState<boolean>(false);

	useEffect(() => {
		if (!behavior.id || !sessionId || flag) return;
		dispatch(getFrequency({ behaviorId: behavior.id, sessionId }))
			.then(unwrapResult)
			.then((response) => {
				setCount(response.count);
				setFlag(false);
			})
			.catch(errorNormalizer);
	}, [behavior, sessionId, flag, dispatch]);

	const addBehaviourFrequency = () => {
		setCount((prev) => prev + 1);
		setFlag(true);
	};

	const removeBehaviourFrequency = () => {
		setCount((prev) => prev - 1);
		setFlag(true);
	};

	useEffect(() => {
		if (!behavior.id || !sessionId || !flag) return;
		const timeout = setTimeout(() => {
			dispatch(
				updateFrequency({
					behaviorId: behavior.id,
					sessionId,
					count,
				}),
			);
		}, 1000);

		// TODO - return void as in return () => void clearTimeout(timeout);
		// eslint-disable-next-line
		return () => clearTimeout(timeout);
	}, [behavior, sessionId, count, flag, dispatch]);

	return (
		<>
			<div className="behaviorTitle">
				{Boolean(behavior.definition) && (
					<div className="infoIcon" onClick={() => setOpenInfo(true)}>
						<InfoFilled color={PRIMARY.BASE} />
					</div>
				)}
				<Text title={behavior.name} style={{ whiteSpace: 'nowrap' }} />
			</div>
			<div className="behaviorAction">
				<CustomButton onClick={removeBehaviourFrequency} disabled={!count} title="-" />
				<Text title={count} type="plg" fontWeight="semiBold" color={TEXT.SECONDARY} />
				<CustomButton onClick={addBehaviourFrequency} buttonType="tertiary" title="+" />
			</div>

			<CustomAlert
				title=""
				open={openInfo}
				onClose={() => setOpenInfo(false)}
				Content={() => <Text title={behavior.definition} type="psm" className="padding16" />}
			/>
		</>
	);
};

export default FrequencyType;
